import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="px-6 py-20" style={{
    backgroundColor: 'var(--color-background-alt)'
  }} data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="text-3xl md:text-4xl font-bold mb-8 text-center" style={{
        fontFamily: 'var(--font-heading)',
        color: 'var(--color-text)'
      }} data-id="element-85">
          The Exhaustion-Guilt Loop
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        ease: 'easeOut',
        delay: 0.1
      }} className="space-y-6" data-id="element-86">
          <p className="text-lg" style={{
          color: 'var(--color-text)'
        }} data-id="element-87">
            Most parents are caught in the "Exhaustion-Guilt Loop." You hand
            over the device because you need ten minutes of peace to cook, work,
            or breathe. But the cost is a <strong data-id="element-88">"dopamine firehose"</strong>{' '}
            that hijacks your child's nervous system.
          </p>

          <div className="p-6 rounded-lg" style={{
          backgroundColor: 'var(--color-background)',
          border: '1px solid var(--color-border)'
        }} data-id="element-89">
            <p className="text-lg italic" style={{
            color: 'var(--color-text)'
          }} data-id="element-90">
              When the screen goes off, their brain experiences a physiological
              crash. They aren't being "naughty"—they are literally in
              withdrawal.
            </p>
          </div>

          <p className="text-lg" style={{
          color: 'var(--color-text)'
        }} data-id="element-91">
            The more you "negotiate" or "bargain," the more power the device
            gains over your family's happiness.
          </p>
        </motion.div>
      </div>
    </section>;
}